export default "__VITE_ASSET__e463e6a2__"